"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const NakedButton_1 = require("@Components/Buttons/NakedButton");
const react_router_dom_1 = require("react-router-dom");
const BackButton = (props) => {
    var _a, _b;
    const navigate = (0, react_router_dom_1.useNavigate)();
    const location = (0, react_router_dom_1.useLocation)();
    const canGoBack = location.key !== 'default';
    const backTo = (_b = (_a = location.state) === null || _a === void 0 ? void 0 : _a.referrer) !== null && _b !== void 0 ? _b : undefined;
    const { text } = props;
    return (react_1.default.createElement(react_1.default.Fragment, null, canGoBack && (react_1.default.createElement(NakedButton_1.NakedButton, { onClick: () => {
            backTo ? navigate(backTo, { state: { referrer: location.pathname } }) : navigate(-1);
        } }, text !== null && text !== void 0 ? text : '< Back'))));
};
exports.default = BackButton;
